import { render } from "./RegisteredTradesScrapingEditing.vue?vue&type=template&id=c12dbece&scoped=true&ts=true"
import script from "./RegisteredTradesScrapingEditing.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesScrapingEditing.vue?vue&type=script&lang=ts"

import "./RegisteredTradesScrapingEditing.vue?vue&type=style&index=0&id=c12dbece&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12dbece"]])

export default __exports__